import type { ConstValues } from './helpers.ts';

export type InventoryListByIdAPI = {
  uid: string;
  type: 'inventorylist';
  v: string;
  id: string;
  account_id: string;
  account_uid: string;
  name: string;
  type_full: TypeFullAPI;
  description?: string;
  values: string[];
  revision: number;
  modified_date: string;
  created_date: string;
  instance_uid: string;
  deleted: string;
};

export type TypeFullAPI = ConstValues<typeof ListTypesAPI>;

type InvalidItemsError = {
  error: string;
  invalidItems: string[];
};

export const InventoryListFormFields = {
  ACCOUNT_UID: 'account_uid',
  NAME: 'name',
  DESCRIPTION: 'description',
  LIST_TYPE: 'type_full',
  VALUES: 'values',
} as const;

export type InventoryListFormState = {
  [InventoryListFormFields.ACCOUNT_UID]: string;
  [InventoryListFormFields.NAME]: string;
  [InventoryListFormFields.LIST_TYPE]: FormTypesKey;
  [InventoryListFormFields.VALUES]: string[];
  [InventoryListFormFields.DESCRIPTION]?: string;
};

export const ListTypesAPI = {
  DOMAIN: 'inventorylist.domain',
  BUNDLE: 'inventorylist.bundle',
} as const;

export const FormTypes = {
  DOMAINS: 'domains',
  BUNDLES: 'bundles',
} as const;

export type FormTypesKey = ConstValues<typeof FormTypes>;

export type ListData = {
  id: string;
  name: string;
  isOnList: boolean;
};

export type InventoryListReducerState = {
  bulkInput: string;
  textareaDisabled: boolean;
  listData: ListData[];
  validItems: string[];
  bulkErrors: InvalidItemsError[];
};

export const Actions = {
  SET_BULK_INPUT: 'SET_BULK_INPUT',
  SET_LIST_DATA: 'SET_LIST_DATA',
  RESET_FORM: 'RESET_FORM',
  VALIDATE: 'VALIDATE',
  CLOSE_ERROR: 'CLOSE_ERROR',
  ADD_ITEMS: 'ADD_ITEMS',
} as const;
export type Actions = ConstValues<typeof Actions>;

export type InventoryListsListFilters = {
  phrase: string;
  account_uid?: string[];
};
